import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { logoutUser } from "../../redux/actions/userAction";
import { clearProducts } from "../../redux/actions/productsAction";
import useToken from "../../hook/useToken";
import { Divider } from "@mui/material";

const FooterMobile = (props) => {
  const { cartData, wishlistData, userData, clearProducts, logoutUser } = props;
  const isUser =
    userData?.user?.user &&
    (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge);
  const location = window.location.pathname;
  console.log(location);
  const wichMenu = isUser
    ? {
        shop:
          location.includes("/shop-grid-full-width") ||
          location.includes("/consigliati"),
        cart: location.includes("/cart"),
        wishlist: location.includes("/wishlist"),
        //first: location.includes('shop-grid-full-width'),
      }
    : {
        shop:
          location.includes("/shop-grid-full-width") ||
          location.includes("/consigliati"),
        home: location === "/",
        about: location.includes("/about"),
        contact: location.includes("/contact"),
        //first: location.includes('shop-grid-full-width'),
      };

  const style = {
    backgroundColor: "white",
    border: "1px solid #E7E7E7",
    textAlign: "center",
    //padding: "20px",
    position: "fixed",
    left: "0",
    bottom: "0",
    height: "40px",
    maxWidth: "100%",
    minWidth: "100%",
    zIndex: "999",
    display: "flex",
    flexWrap: "wrap",
  };

  const spanStyle = {
    position: "absolute",
    top: "-9px",
    //right: '-14px',
    color: "#000",
    backgroundColor: "#fff",
    "&:hover": {
      color: "blue",
    },
    display: "inline-block",
    width: "21px",
    height: "21px",
    borderRadius: "40px",
    lineHeight: "21px",
    fontSize: "12px",
    textAlign: "center",
  };

  const selezionato = {
    paddingTop: "4px",
    borderTop: "3px",
    borderColor: "black",
    borderStyle: "solid",
  };

  const { token, setToken } = useToken();
  const history = useHistory();

  const hLogOutUser = async (e) => {
    e.preventDefault();
    logoutUser();
    clearProducts();
    setToken(0);
    history.push(process.env.PUBLIC_URL + "/");
  };

  const handleClick = (e) => {
    e.currentTarget.nextSibling.classList.toggle("active");
    //console.log(userData);
  };

  const noUserLogin = () => {
    return (
      <div style={style} className="d-flex d-lg-none">
        <div
          className="col-3"
          style={{
            paddingTop: "4px",
            border: "solid",
            borderWidth: "0px",
            height: "100%",
            ...(wichMenu.shop ? selezionato : {}),
          }}
        >
          <Link
            className="icon-wishList"
            to={process.env.PUBLIC_URL + "/shop-grid-full-width/"}
          >
            <i className="pe-7s-home fa-2x" style={{ color: "black" }} />
          </Link>
        </div>
        <div
          className="col-3"
          style={{
            paddingTop: "4px",
            border: "solid",
            borderWidth: "0px",
            height: "100%",
          }}
        >
          <a
            className="default-btn"
            style={{ border: "0px", padding: "0px" }}
            href="/files/catalogoDGA.pdf"
          >
            <i className="pe-7s-shopbag fa-2x" style={{ color: "black" }} />
          </a>
        </div>
        {global.aziendaID != 4 && (
          <div
            className="col-3"
            style={{
              paddingTop: "4px",
              border: "solid",
              borderWidth: "0px",
              height: "100%",
              ...(wichMenu.about ? selezionato : {}),
            }}
          >
            <Link
              className="icon-wishList"
              to={process.env.PUBLIC_URL + "/about/"}
            >
              <i className="pe-7s-users fa-2x" style={{ color: "black" }} />
            </Link>
          </div>
        )}
        <div
          className="col-3"
          style={{
            paddingTop: "4px",
            border: "solid",
            borderWidth: "0px",
            height: "100%",
            ...(wichMenu.contact ? selezionato : {}),
          }}
        >
          <Link
            className="icon-wishList"
            to={process.env.PUBLIC_URL + "/contact/"}
          >
            <i className="pe-7s-headphones fa-2x" style={{ color: "black" }} />
          </Link>
        </div>
      </div>
    );
  };
  if (!isUser && (global.aziendaID == 2 || global.aziendaID == 4)) return null;
  if (!isUser) return noUserLogin();

  return (
    <div style={style} className="d-flex d-lg-none">
      <div
        className="col-3"
        style={{
          paddingTop: "4px",
          border: "solid",
          borderWidth: "0px",
          height: "100%",
          ...(wichMenu.shop ? selezionato : {}),
        }}
      >
        <Link
          className="icon-wishList"
          to={process.env.PUBLIC_URL + "/shop-grid-full-width/"}
        >
          <i className="pe-7s-home fa-2x" style={{ color: "black" }} />
        </Link>
      </div>
      <div
        className="col-3"
        style={{
          paddingTop: "4px",
          border: "solid",
          borderWidth: "0px",
          height: "100%",
          ...(wichMenu.cart ? selezionato : {}),
        }}
      >
        <Link className="icon-wishList" to={process.env.PUBLIC_URL + "/cart/"}>
          <i className="pe-7s-shopbag fa-2x" style={{ color: "black" }} />
          <span className="count-style" style={{ ...spanStyle }}>
            {cartData && cartData.length ? cartData.length : 0}
          </span>
        </Link>
      </div>
      <div
        className="col-3"
        style={{
          paddingTop: "4px",
          border: "solid",
          borderWidth: "0px",
          height: "100%",
          ...(wichMenu.wishlist ? selezionato : {}),
        }}
      >
        <Link
          className="icon-wishList"
          to={process.env.PUBLIC_URL + "/wishlist/"}
        >
          <i className="pe-7s-like fa-2x" style={{ color: "black" }} />
          <span className="count-style" style={{ ...spanStyle }}>
            {wishlistData && wishlistData.length ? wishlistData.length : 0}
          </span>
        </Link>
      </div>

      <div
        className="col-3"
        style={{
          paddingTop: "4px",
          border: "solid",
          borderWidth: "0px",
          height: "100%",
          ...(wichMenu.shop ? selezionato : {}),
        }}
      >
        <div className="header-right-wrap" style={{ justifyContent: "center" }}>
          <div className="same-style account-setting  d-lg-block">
            <button
              className="account-setting-active"
              onClick={(e) => handleClick(e)}
            >
              <img
                style={{ height: 35, width: 35, borderRadius: 25 }}
                src={
                  userData?.user?.user?.WebImage
                    ? userData.user.user.WebImage
                    : "https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"
                }
              ></img>
            </button>

            <div
              className="account-dropdown"
              style={{ top: "-180px", left: "-125px", width: "150px" }}
            >
              <ul>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/my-account"}>
                    Il mio Account
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/my-documents"}>
                    I miei documenti{" "}
                  </Link>
                </li>
                {global.aziendaID == 1 ? (
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/my-pricelist"}>
                      Il mio listino{" "}
                    </Link>
                  </li>
                ) : null}
                <Divider fullWisth />
                {global.aziendaID == 1 ? (
                  <li>
                    <a
                      className="default-btn"
                      style={{ border: "0px" }}
                      href="/files/catalogoDGA.pdf"
                    >
                      {"Scarica catalogo"}
                    </a>
                  </li>
                ) : null}
                <Divider fullWisth />
                <li>
                  <Link onClick={(e) => hLogOutUser(e)}>Disconnetti </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FooterMobile.propTypes = {
  cartData: PropTypes.array,
  currency: PropTypes.object,
  wishlistData: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    currency: state.currencyData,
    cartData: state.cartData,
    wishlistData: state.wishlistData,
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logoutUser: () => {
      dispatch(logoutUser());
    },
    clearProducts: () => {
      dispatch(clearProducts());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterMobile);
